import { Button } from "primereact/button";
import GenericFileUpload from "../../../../../components/common/GenericFileUpload";

const ACCEPTED_FILE_TYPES = {
    'image/*':         ['.png', '.jpg', '.jpeg', '.gif'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'text/plain':      ['.txt']
};

const DealerDocumentsSection = ({
    dealerDocuments,
    newFiles,
    onFilesChange,
    onDownloadDocument,
    onDownloadAll,
    onDeleteDocument,
    isLoading,
    isWarrantyTeam,
    canUpload,
    isProcessingFiles,
    th
}) => (
    <div>
        <div className="grid align-items-center mb-3">
            <h4 className="col-8 font-semibold m-0">
                <i className="pi pi-user mr-2 text-primary"></i>
                {th('preApproval.form.dealerDocumentsTitle')}
            </h4>
            {dealerDocuments?.length > 0 && (
                <div className="col-4 flex justify-content-end">
                    <Button
                        type="button"
                        icon="pi pi-download"
                        label={th('preApproval.fileOperations.downloadAll')}
                        className="p-button-sm p-button-outlined"
                        onClick={onDownloadAll}
                        disabled={isProcessingFiles}
                    />
                </div>
            )}
        </div>
        <GenericFileUpload
            newFiles={newFiles}
            onFilesChange={onFilesChange ?? (() => {})}
            existingDocuments={dealerDocuments}
            onDownloadDocument={onDownloadDocument}
            onDeleteExistingDocument={!isWarrantyTeam && onDeleteDocument ? onDeleteDocument : null}
            isLoading={isLoading}
            maxFileSize={20971520}
            disabled={!canUpload || isProcessingFiles}
            multiple
            readOnlyMode={isWarrantyTeam}
            acceptedFileTypes={ACCEPTED_FILE_TYPES}
        />
    </div>
);
 
const WarrantyDocumentsSection = ({
    warrantyDocuments,
    newFiles,
    onFilesChange,
    onDownloadDocument,
    onDownloadAll,
    onDeleteDocument,
    isLoading,
    isWarrantyTeam,
    canUpload,
    isProcessingFiles,
    th
}) => (
    <div>
        <div className="grid align-items-center mb-3">
            <h4 className="col-8 font-semibold m-0">
                <i className="pi pi-user mr-2 text-primary"></i>
                {th('preApproval.form.warrantyDocumentsTitle')}
            </h4>
            {warrantyDocuments?.length > 0 && (
                <div className="col-4 flex justify-content-end">
                    <Button
                        type="button"
                        icon="pi pi-download"
                        label={th('preApproval.fileOperations.downloadAll')}
                        className="p-button-sm p-button-outlined"
                        onClick={onDownloadAll}
                        disabled={isProcessingFiles}
                    />
                </div>
            )}
        </div>
        <GenericFileUpload
            newFiles={newFiles}
            onFilesChange={onFilesChange ?? (() => {})}
            existingDocuments={warrantyDocuments}
            onDownloadDocument={onDownloadDocument}
            onDeleteExistingDocument={isWarrantyTeam && onDeleteDocument ? onDeleteDocument : null}
            isLoading={isLoading}
            maxFileSize={20971520}
            disabled={!canUpload || isProcessingFiles}
            multiple
            readOnlyMode={!isWarrantyTeam}
            acceptedFileTypes={ACCEPTED_FILE_TYPES}
        />
    </div>
);

export { DealerDocumentsSection, WarrantyDocumentsSection, ACCEPTED_FILE_TYPES };